// ensure this value is only instantiated once
// HMR will return the original one
export function hmrValue<T>(
  name: string,
  cb: () => T,
  hmr: ImportMeta["hot"] | undefined
): T {
  if (import.meta.hot) {
    if (!hmr) {
      throw new Error(`hmrValue: missing hmr object for ${name}`);
    }
    return (hmr.data[name] ??= cb());
  }
  return cb();
}
